window.SETTINGS = {
    layers: {
        version: $('#screens .screen.settings .version span'),
        general_info: {
            input: $('#screens .screen.settings .general form input'),
            name: $('#screens .screen.settings .general form input[name=name]'),
            email: $('#screens .screen.settings .general form input[name=email]'),
            sms_notify: $('#screens .screen.settings .general form input[name=sms-notify]'),
            email_notify: $('#screens .screen.settings .general form input[name=email-notify]'),
            select: $('#screens .screen.settings .change-password form select'),
            submit_btn: $('#screens .screen.settings .general form .uk-margin.submit button'),
            form: $('#screens .screen.settings .general form'),
            lang: $('#form-settings-lang')
        },

        logount_btn: $('#screens .screen.settings button.exit'),
        auth: {
            edit_card_btn: $('#screens .screen.settings .auth .card-list .card .delete'),
            edit_card_window: $('#auth-edit-card'),
            edit_card_window_cross: $('#auth-edit-card .auth-edit-card-title .cross'),
            edit_card_window_name: $('#form-auth-edit-card-phone'),
            edit_card_window_pk: $('#form-auth-edit-card-id'),
            edit_card_submit: $('#auth-edit-card .auth-edit-card-content form .uk-margin.submit button'),
            edit_card_form: $('#auth-edit-card .auth-edit-card-content form'),
            edit_card_delete: $('#auth-edit-card .auth-edit-card-content button.delete')
        },

        add_card: {
            tab_title: $('#auth-add-card .auth-add-card-content .tabs-layer .tabs-title-layer .tabs-title'),
            tab_layer: $('#auth-add-card .auth-add-card-content .tabs-layer'),
            add_window: $('#auth-add-card'),
            add_window_cross: $('#auth-add-card .auth-add-card-title .cross'),
            add_btn: $('#screens .screen.settings .auth .card-list .card.add')
        },

        change_password: {
            layer: $('#screens .screen.settings .charge-password'),
            title: $('#screens .screen.settings .charge-password .title'),
            password_old: $('#screens .screen.settings .charge-password #form-settings-charge-password-old'),
            password_new: $('#screens .screen.settings .charge-password #form-settings-charge-password-new'),
            password_new_confirm: $('#screens .screen.settings .charge-password #form-settings-charge-password-new-confirm'),
            submit: $('#screens .screen.settings .charge-password button[type=submit]'),
            input: $('#screens .screen.settings .charge-password input'),
            form: $('#screens .screen.settings .charge-password form'),
        },

        referal_link: '#referal_link_btn',
        card_list: '#screens .screen.settings .bank-cards .card-list .card',
    },

    findAuthCardName: function (pk) {
        return $('#screens .screen.settings .auth .card-list .card .delete[data-pk='+ pk +']').closest('.card').find('.name');
    },
    findAuthCard: function (pk) {
        return $('#screens .screen.settings .auth .card-list .card .delete[data-pk='+ pk +']').closest('.card');
    },

    init: async () => {
    window.SETTINGS.layers.version.html(window.version);

        window.SETTINGS.layers.general_info.input.on("change", function () {
            window.SETTINGS.change_general_info();
        });
        window.SETTINGS.layers.general_info.input.on("keyup", function () {
            window.SETTINGS.change_general_info();
        });

        window.SETTINGS.layers.logount_btn.click(function () {
            window.WS.logout();
        });

        window.SETTINGS.layers.auth.edit_card_btn.click(function () {
            if(!window.SETTINGS.layers.auth.edit_card_window.hasClass('active')) {
                window.SETTINGS.layers.auth.edit_card_window_name.val($(this).closest('.card').find('.name').html());
                window.SETTINGS.layers.auth.edit_card_window_pk.val($(this).attr('data-pk'));
                window.SETTINGS.layers.auth.edit_card_window.addClass('active');
            }
        });

        window.SETTINGS.layers.auth.edit_card_window_name.on("change", function () {
            if(window.SETTINGS.layers.auth.edit_card_submit.prop('disabled')) {
                window.SETTINGS.layers.auth.edit_card_submit.prop('disabled', false);
            }
        });

        window.SETTINGS.layers.auth.edit_card_window_cross.click(function () {
            if(window.SETTINGS.layers.auth.edit_card_window.hasClass('active')) {
                window.SETTINGS.layers.auth.edit_card_window.removeClass('active');

                if(!window.SETTINGS.layers.auth.edit_card_submit.prop('disabled')) {
                    window.SETTINGS.layers.auth.edit_card_submit.prop('disabled', true);
                }
            }
        });

        window.SETTINGS.layers.auth.edit_card_delete.click(function () {
            if (window.confirm(window.delete_auth_confirm +' '+ window.SETTINGS.layers.auth.edit_card_window_name.val() +'?')){
                window.WS.send_auth_delete(window.SETTINGS.layers.auth.edit_card_window_pk.val());
            }
        });

        window.SETTINGS.layers.add_card.tab_title.click(function () {
            if(!$(this).hasClass('active')) {
                window.SETTINGS.layers.add_card.tab_title.removeClass('active');
                $(this).addClass('active');

                window.SETTINGS.layers.add_card.tab_layer.removeClass('now-key');
                window.SETTINGS.layers.add_card.tab_layer.removeClass('no-key');
                window.SETTINGS.layers.add_card.tab_layer.addClass($(this).attr('data-key'));
            }
        });

        window.SETTINGS.layers.add_card.add_btn.click(function () {
            if(!window.SETTINGS.layers.add_card.add_window.hasClass('active')) {
                window.SETTINGS.layers.add_card.add_window.addClass('active');
            }
        });

        window.SETTINGS.layers.add_card.add_window_cross.click(function () {
            if(window.SETTINGS.layers.add_card.add_window.hasClass('active')) {
                window.SETTINGS.layers.add_card.add_window.removeClass('active');
            }
        });

        /* SUBMIT */
        window.SETTINGS.layers.auth.edit_card_form.on('submit', function () {
            window.WS.send_auth_edit(window.SETTINGS.layers.auth.edit_card_window_pk.val(), window.SETTINGS.layers.auth.edit_card_window_name.val());

            if(window.SETTINGS.layers.auth.edit_card_submit.prop('disabled') == false) {
                window.SETTINGS.layers.auth.edit_card_submit.prop('disabled', true);
            }
            return false;
        });

        window.SETTINGS.layers.general_info.form.on('submit', function () {
            var name = window.SETTINGS.layers.general_info.name.val();
            var email = window.SETTINGS.layers.general_info.email.val();
            var sms_notify = window.SETTINGS.layers.general_info.sms_notify.prop('checked');
            var email_notify = window.SETTINGS.layers.general_info.email_notify.prop('checked');

            window.WS.general_info_form(name, email, sms_notify, email_notify);

            window.SETTINGS.layers.general_info.submit_btn.prop('disabled', true);
            return false;
        });

        window.SETTINGS.layers.change_password.title.click(function () {
            if(window.SETTINGS.layers.change_password.layer.hasClass('open')) {
                window.SETTINGS.layers.change_password.layer.removeClass('open');
            } else {
                window.SETTINGS.layers.change_password.layer.addClass('open');
            }
        });

        var clipboard = new ClipboardJS(window.SETTINGS.layers.referal_link);
        clipboard.on('success', function (e) {
            window.NOTIFFICATIONS.open_referall_link_copy_success();
        });

        if($(window.SETTINGS.layers.card_list).length > 0) {

            $(window.SETTINGS.layers.card_list +'.click').click(function () {

                if($(this).hasClass('default')) {

                    $(window.SETTINGS.layers.card_list +'.click').removeClass('default');

                    setTimeout(function () {
                        location.reload();
                    }, 2000);

                } else {
                    $(window.SETTINGS.layers.card_list +'.click').removeClass('default');

                    $(this).addClass('default');
                }

                window.WS.default_bank_card($(this).attr('data-id'));
            });

            $(window.SETTINGS.layers.card_list +'.click .delete').click(function (e) {
                e.stopPropagation();
                if (window.confirm($(this).attr('data-confirm'))) {
                    window.WS.delete_bank_card($(this).closest('.card').attr('data-id'));
                }
            });

            $(window.SETTINGS.layers.card_list +'.add').click(function () {
                $('#bank-cards-add').submit();
            });
        }

        window.SETTINGS.layers.change_password.input.on("change", function () {
            window.SETTINGS.change_password_check();
        });
        window.SETTINGS.layers.change_password.input.on("keyup", function () {
            window.SETTINGS.change_password_check();
        });

        window.SETTINGS.layers.change_password.form.on("submit", function () {
            window.WS.change_password(window.SETTINGS.layers.change_password.password_old.val(), window.SETTINGS.layers.change_password.password_new.val(), window.SETTINGS.layers.change_password.password_new_confirm.val());
            return false;
        });

        /* check GET */
        switch (window.getUrlParameter('w')) {
            case "auth":
                $(document).ready(function () {
                    window.LOGIN.layers.map_login_btn.click();
                });
            break;
            case "settings":
                $(document).ready(function () {
                    window.MENU.layers.items.settings.click();
                });
            break;
        }
    },

    change_general_info: async () => {
        if(window.SETTINGS.layers.general_info.submit_btn.prop('disabled')) {
            window.SETTINGS.layers.general_info.submit_btn.prop('disabled', false);
        }
    },

    events: {
        change_general_select: async () => {
            window.location.href = window.SETTINGS.layers.general_info.lang.val();
        }
    },

    change_password_check: async () => {
        let status = false;

        if('' !=  window.SETTINGS.layers.change_password.password_old.val() && '' !=  window.SETTINGS.layers.change_password.password_new.val() && '' !=  window.SETTINGS.layers.change_password.password_new_confirm.val() && window.SETTINGS.layers.change_password.password_new.val() == window.SETTINGS.layers.change_password.password_new_confirm.val() ) {
            status = true;
        }

        if(status) {
            if(window.SETTINGS.layers.change_password.submit.prop('disabled')) {
                window.SETTINGS.layers.change_password.submit.prop('disabled', false);
            }
        } else {
            if(!window.SETTINGS.layers.change_password.submit.prop('disabled')) {
                window.SETTINGS.layers.change_password.submit.prop('disabled', true);
            }
        }

    }
};
window.SETTINGS.init();
